const reObjectId = /^[a-f0-9]{24}$/i;
export const isObjectId = (id: unknown): id is string =>
  typeof id === 'string' && reObjectId.test(id);
